import store from '@/store/index'
let funcEnable = store.state.switchConfigStore.funcEnable

/**
 * 获取展会类型
 * @param {Object} 展会配置信息
 */
export const __setExhiType = (exhiConfig) => {
    let result = ''
    if (!exhiConfig || !Object.keys(exhiConfig) || !exhiConfig.exhiId) {
        result = ''
    } else if (!exhiConfig.exhiFrom) {
        result = 'manualExhi' // 手工创建展会
    } else if (exhiConfig.exhiFrom === '1') {
        result = 'CIMSExhi' // cims展会
    } else if (exhiConfig.exhiFrom === '3') {
        result = 'MRSSingleExhi' // MRS单团祖展会
    } else if (exhiConfig.exhiFrom === '4') {
        result = 'MRSMultipleExhi' // MRS多团组展会
    }
    store.commit('common/setExhiType', result)
    return result
}

/**
 * 设置相关功能是否启用  根据展会类型
 */
export const __setFunctionEnableByExhiType = (exhiType) => {
    if (exhiType === 'manualExhi') {
        funcEnable = getManualExhiEnable(funcEnable)
    } else if (exhiType === 'CIMSExhi') {
        funcEnable = getCIMSExhiEnable(funcEnable)
    } else if (exhiType === 'MRSSingleExhi') {
        funcEnable = getMRSSingleExhiEnable(funcEnable)
    } else if (exhiType === 'MRSMultipleExhi') {
        funcEnable = getMRSMultipleExhiEnable(funcEnable)
    }
    store.commit('switchConfigStore/setFuncEnable', funcEnable)
}

// 手工展会的功能启用
const getManualExhiEnable = (enable) => {
    enable.navigation.person = false
    enable.navigation.hotel.companyHotel = false
    enable.navigation.vehicle.companyVehicle = false
    enable.myOrder.hotel.companyHotel = false
    enable.myOrder.vehicle.companyVehicle = false
    enable.myToDo = false
    enable.personManage = false
    enable.switchConfig.processSwitch = false
    enable.resourceConfig.hotel.companyHotel = false
    enable.financialManagement.financialStatement.inventory = false
    enable.financialManagement.financialStatement.checkIn = false
    enable.financialManagement.financialStatement.sale = false
    return enable
}

// CIMS展会的功能启用
const getCIMSExhiEnable = (enable) => {
    enable.navigation.person = false
    enable.myToDo = false
    enable.personManage = false
    enable.switchConfig.processSwitch = false
    enable.financialManagement.financialStatement.inventory = false
    enable.financialManagement.financialStatement.checkIn = false
    enable.financialManagement.financialStatement.sale = false
    return enable
}

// MRS单团祖展会的功能启用
const getMRSSingleExhiEnable = (enable) => {
    enable.navigation.hotel.companyHotel = false
    enable.navigation.hotel.travelHotel = false
    enable.navigation.vehicle.companyVehicle = false
    enable.navigation.vehicle.travelVehicle = false
    enable.navigation.airTicket = false
    enable.navigation.trainTicket = false
    enable.myOrder.hotel.companyHotel = false
    enable.myOrder.hotel.travelHotel = false
    enable.myOrder.vehicle.companyVehicle = false
    enable.myOrder.vehicle.travelVehicle = false
    enable.orderManage.travelBooking.hotelOrder = false
    enable.orderManage.travelBooking.vehicleOrder = false
    enable.resourceConfig.hotel.companyHotel = false
    enable.resourceConfig.travelVehicle = false
    enable.resourceConfig.airTicket = false
    enable.resourceConfig.trainTicket = false
    enable.financialManagement.financialStatement.inventory = false
    enable.financialManagement.financialStatement.checkIn = false
    enable.financialManagement.financialStatement.sale = false
    return enable
}

// MRS多团组展会的功能启用
const getMRSMultipleExhiEnable = (enable) => {
    enable.navigation.person = false
    enable.navigation.hotel.companyHotel = false
    enable.navigation.vehicle.companyVehicle = false
    enable.myOrder.hotel.companyHotel = false
    enable.myOrder.vehicle.companyVehicle = false
    enable.myToDo = false
    enable.personManage = false
    enable.resourceConfig.hotel.companyHotel = false
    return enable
}

// 根据资源开关配置信息设置功能启用
export const __setFunctionEnableByResourceSwitch = (resourceSwitch) => {
    funcEnable.navigation.person = resourceSwitch.personnel === 'Y'
    funcEnable.navigation.hotel.companyHotel = resourceSwitch.hotel === 'Y' && resourceSwitch.hotelCompany === 'Y'
    funcEnable.navigation.hotel.travelHotel = resourceSwitch.hotel === 'Y' && resourceSwitch.hotelBusiness === 'Y'
    funcEnable.navigation.hotel.personalHotel = resourceSwitch.hotel === 'Y' && resourceSwitch.hotelPersonal === 'Y'
    funcEnable.navigation.vehicle.companyVehicle = resourceSwitch.useVehicle === 'Y' && resourceSwitch.useVehicleCompany === 'Y'
    funcEnable.navigation.vehicle.travelVehicle = resourceSwitch.useVehicle === 'Y' && resourceSwitch.useVehicleBusiness === 'Y'
    funcEnable.navigation.airTicket = resourceSwitch.aircraft === 'Y'
    funcEnable.navigation.trainTicket = resourceSwitch.train === 'Y'
    store.commit('switchConfigStore/setFuncEnable', funcEnable)
}
// 根据是否存在订单和是否启用对应资源入口,决定订单和订单管理模块是否开放
// 仅没有订单且关闭对应资源入口时 关闭对应订单模块,其余情况开放
export const __setOrderEnable = (orderExists) => {
    funcEnable.myOrder.hotel.companyHotel = funcEnable.navigation.hotel.companyHotel || orderExists.hotelCompanyOrderExists
    funcEnable.myOrder.hotel.travelHotel = funcEnable.navigation.hotel.travelHotel || orderExists.hotelBusinessOrderExists
    funcEnable.myOrder.hotel.personalHotel = funcEnable.navigation.hotel.personalHotel || orderExists.hotelPersonalOrderExists
    funcEnable.myOrder.recentOrder = funcEnable.myOrder.hotel.companyHotel || funcEnable.myOrder.hotel.travelHotel || funcEnable.myOrder.hotel.personalHotel
    funcEnable.myOrder.vehicle.companyVehicle = funcEnable.navigation.vehicle.companyVehicle || orderExists.vehicleCompanyOrderExists
    funcEnable.myOrder.vehicle.travelVehicle = funcEnable.navigation.vehicle.travelVehicle || orderExists.vehicleBusinessOrderExists
    store.commit('switchConfigStore/setFuncEnable', funcEnable)
}
